import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .header-wrapper {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n\n  .fa-cog {\n    color: white;\n  }\n\n  .loading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .btn-wrapper {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { createElement, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import useSWRImmutable from 'swr/immutable';
import useSWR from 'swr';
import { v4 as uuidV4 } from 'uuid';
import { TwoFactorAuthenticationMethods, TwoFactorAuthenticationStates } from '@tradingblock/types';
import { GetAccountManagementDetailsUrl } from '@tradingblock/api';
import { Loading } from '../common';
import SuccessView from './views/Success';
import ContactInfoView from './views/ContactInfo';
import IntroView from './views/Intro';
import EnterSecurityCodeView from './views/EnterSecurityCode';
var StyledTwoFactorAuthenticationSetup = styled.div(_templateObject());
var Views;

(function (Views) {
  Views["Intro"] = "Intro";
  Views["ContactInfo"] = "ContactInfo";
  Views["EnterSecurityCode"] = "EnterSecurityCode";
  Views["Success"] = "Success";
})(Views || (Views = {}));

;
export var ContextTypes;

(function (ContextTypes) {
  ContextTypes["login"] = "login";
  ContextTypes["accountManagementBlock"] = "accountManagementBlock";
})(ContextTypes || (ContextTypes = {}));

;
export var TwoFactorAuthenticationMethodVerificationStepsOverrideStates;

(function (TwoFactorAuthenticationMethodVerificationStepsOverrideStates) {
  TwoFactorAuthenticationMethodVerificationStepsOverrideStates["UserInitiatedSmsTwoFactorAuthenticationMethodVerification"] = "UserInitiatedSmsTwoFactorAuthenticationMethodVerification";
  TwoFactorAuthenticationMethodVerificationStepsOverrideStates["UserInitiatedEmailTwoFactorAuthenticationMethodVerification"] = "UserInitiatedEmailTwoFactorAuthenticationMethodVerification";
})(TwoFactorAuthenticationMethodVerificationStepsOverrideStates || (TwoFactorAuthenticationMethodVerificationStepsOverrideStates = {}));

;
;
;
export var TwoFactorAuthenticationSetup = function TwoFactorAuthenticationSetup(_ref) {
  var primaryBtnClassName = _ref.primaryBtnClassName,
      primaryBtnIcon = _ref.primaryBtnIcon,
      primaryBtnIconClassName = _ref.primaryBtnIconClassName,
      handleEmailUpdate = _ref.handleEmailUpdate,
      handlePhoneUpdate = _ref.handlePhoneUpdate,
      mainHeaderHtmlTag = _ref.mainHeaderHtmlTag,
      api = _ref.api,
      accountId = _ref.accountId,
      handleSetupComplete = _ref.handleSetupComplete,
      mainHeaderIconClassName = _ref.mainHeaderIconClassName,
      mainHeaderIconStyles = _ref.mainHeaderIconStyles,
      mainHeaderStyles = _ref.mainHeaderStyles,
      rootRestHubUrl = _ref.rootRestHubUrl,
      handleAuthTokenExpiration = _ref.handleAuthTokenExpiration,
      context = _ref.context,
      customRequestUserProfile = _ref.customRequestUserProfile,
      twoFactorAuthenticationMethodVerificationStepsOverrideState = _ref.twoFactorAuthenticationMethodVerificationStepsOverrideState,
      allowAbilityToCancel = _ref.allowAbilityToCancel,
      cancelBtnClassName = _ref.cancelBtnClassName,
      handleCancel = _ref.handleCancel,
      smsTwoFactorAuthenticationMethodVerifiedPhoneData = _ref.smsTwoFactorAuthenticationMethodVerifiedPhoneData,
      receiveAccountManagementDetails = _ref.receiveAccountManagementDetails,
      siteGrp = _ref.siteGrp;
  var MainHeader = useCallback(function () {
    return createElement(mainHeaderHtmlTag, {
      style: mainHeaderStyles || {}
    }, 'Two-factor Authentication');
  }, [mainHeaderHtmlTag, mainHeaderStyles]);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      errorMsg = _useState2[0],
      setErrorMsg = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      primaryAccountHolderEmail = _useState4[0],
      setPrimaryAccountHolderEmail = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      primaryAccountHolderPhones = _useState6[0],
      setPrimaryAccountHolderPhones = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      twoFactorAuthenticationState = _useState8[0],
      setTwoFactorAuthenticationState = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      verifyStepsData = _useState10[0],
      setVerifyStepsData = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      verifyStepsIndex = _useState12[0],
      setVerifyStepsIndex = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      phoneNumberToUseForTwoFactorAuthentication = _useState14[0],
      setPhoneNumberToUseForTwoFactorAuthentication = _useState14[1];

  var prevTwoFactorAuthenticationState = useRef(twoFactorAuthenticationState); // The message below should never get triggered but is here just in case this component in the dashboard gets a 200 response code prior to the web socket message.

  var fallbackAuthTokenExpiredMsg = 'You have been logged out. Please log in again.';
  var genericErrorMsg = "There was an issue on our end. ".concat(context === 'login' ? 'Try refreshing the page.' : 'Try moving to a different tab within the account management block and try again.', " If the issue persists, please contact Customer Service.");
  var uuidForGetProfileKey = useMemo(function () {
    return uuidV4();
  }, []);

  var _useSWRImmutable = useSWRImmutable(!twoFactorAuthenticationMethodVerificationStepsOverrideState ? "".concat(rootRestHubUrl, "/User/GetProfile").concat(uuidForGetProfileKey) : null, api.user.profile, {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  }),
      isLoadingUserProfileData = _useSWRImmutable.isLoading,
      getUserProfileResponse = _useSWRImmutable.data,
      errorGettingUserProfileData = _useSWRImmutable.error,
      isValidatingUserProfileData = _useSWRImmutable.isValidating,
      getUserProfileData = _useSWRImmutable.mutate;

  var _useSWR = useSWR(accountId ? "".concat(rootRestHubUrl).concat(GetAccountManagementDetailsUrl, "?accountId=").concat(accountId) : null, function () {
    return api.accounts.getUserAccountDetails({
      accountId: accountId
    });
  }, {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  }),
      isLoadingAccountManagementDetailsData = _useSWR.isLoading,
      getAccountManagementDetailsResponse = _useSWR.data,
      errorGettingAccountManagementDetailsData = _useSWR.error,
      isValidatingAccountManagementDetailsData = _useSWR.isValidating;

  useEffect(function () {
    return function () {
      if (customRequestUserProfile) {
        customRequestUserProfile();
      }
    };
  }, []);
  useEffect(function () {
    if (!twoFactorAuthenticationMethodVerificationStepsOverrideState) {
      if (getUserProfileResponse && getUserProfileResponse.responseCode === 0 && getUserProfileResponse.payload && getUserProfileResponse.payload.twoFactorAuthenticationState) {
        setTwoFactorAuthenticationState(getUserProfileResponse.payload.twoFactorAuthenticationState);
      } else if (getUserProfileResponse && getUserProfileResponse.responseCode === 200) {
        if (handleAuthTokenExpiration) {
          handleAuthTokenExpiration();
        } else {
          setErrorMsg(fallbackAuthTokenExpiredMsg);
        }
      } else if (!isLoadingUserProfileData && !isValidatingUserProfileData && !getUserProfileResponse || getUserProfileResponse && (!getUserProfileResponse.payload || !getUserProfileResponse.payload.twoFactorAuthenticationState || getUserProfileResponse.responseCode !== 0)) {
        setErrorMsg(genericErrorMsg);
      }
    }
  }, [getUserProfileResponse, isLoadingUserProfileData, isValidatingUserProfileData]);
  useEffect(function () {
    if (getAccountManagementDetailsResponse && getAccountManagementDetailsResponse.responseCode === 0 && getAccountManagementDetailsResponse.payload) {
      setPrimaryAccountHolderEmail(getAccountManagementDetailsResponse.payload.accountHolders[0].email);
      setPrimaryAccountHolderPhones(getAccountManagementDetailsResponse.payload.accountHolders[0].phones);

      if (receiveAccountManagementDetails) {
        receiveAccountManagementDetails(getAccountManagementDetailsResponse.payload);
      }
    } else if (getAccountManagementDetailsResponse && getAccountManagementDetailsResponse.responseCode === 200) {
      if (handleAuthTokenExpiration) {
        handleAuthTokenExpiration();
      } else {
        setErrorMsg(fallbackAuthTokenExpiredMsg);
      }
    } else if (!isLoadingAccountManagementDetailsData && !isValidatingAccountManagementDetailsData && !getAccountManagementDetailsResponse || getAccountManagementDetailsResponse && (!getAccountManagementDetailsResponse.payload || getAccountManagementDetailsResponse.responseCode !== 0)) {
      setErrorMsg(genericErrorMsg);
    }
  }, [getAccountManagementDetailsResponse, isLoadingAccountManagementDetailsData, isValidatingAccountManagementDetailsData]);
  useEffect(function () {
    if (errorGettingAccountManagementDetailsData || errorGettingUserProfileData) {
      setErrorMsg(genericErrorMsg);
    }
  }, [errorGettingAccountManagementDetailsData, errorGettingUserProfileData]); // This will determine the set of steps needed for a custom verification.

  useEffect(function () {
    if (twoFactorAuthenticationMethodVerificationStepsOverrideState && primaryAccountHolderEmail && primaryAccountHolderPhones) {
      if (twoFactorAuthenticationMethodVerificationStepsOverrideState === TwoFactorAuthenticationMethodVerificationStepsOverrideStates.UserInitiatedEmailTwoFactorAuthenticationMethodVerification) {
        setVerifyStepsData([{
          view: Views.ContactInfo,
          viewProps: {
            contactInfoToDisplay: primaryAccountHolderEmail,
            handleContactInfoUpdate: handleEmailUpdate,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIconClassName: primaryBtnIconClassName,
              primaryBtnIcon: primaryBtnIcon,
              onClick: function onClick() {
                return setVerifyStepsIndex(verifyStepsIndex + 1);
              }
            },
            twoFactorAuthenticationMethodToBeVerified: TwoFactorAuthenticationMethods.email,
            context: context,
            genericErrorMsg: genericErrorMsg,
            allowAbilityToCancel: allowAbilityToCancel,
            cancelBtnProps: {
              className: cancelBtnClassName,
              onClick: handleCancel
            }
          }
        }, {
          view: Views.EnterSecurityCode,
          viewProps: {
            twoFactorAuthenticationMethodToBeVerified: TwoFactorAuthenticationMethods.email,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              btnType: 'submit'
            },
            contactInfoToUseForTwoFactorAuthentication: primaryAccountHolderEmail,
            handleNextViewNavigation: function handleNextViewNavigation() {
              return setVerifyStepsIndex(verifyStepsIndex + 1);
            },
            fallbackAuthTokenExpiredMsg: fallbackAuthTokenExpiredMsg,
            genericErrorMsg: genericErrorMsg,
            handleEmailUpdate: handleEmailUpdate,
            rootRestHubUrl: rootRestHubUrl,
            api: api,
            handleAuthTokenExpiration: handleAuthTokenExpiration,
            context: context,
            allowAbilityToCancel: allowAbilityToCancel,
            cancelBtnProps: {
              className: cancelBtnClassName,
              onClick: handleCancel
            }
          }
        }, {
          view: Views.Success,
          viewProps: {
            verifiedTwoFactorAuthenticationMethod: TwoFactorAuthenticationMethods.email,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              onClick: handleSetupComplete,
              btnTextOverride: 'Close'
            }
          }
        }]);
      } else if (twoFactorAuthenticationMethodVerificationStepsOverrideState === TwoFactorAuthenticationMethodVerificationStepsOverrideStates.UserInitiatedSmsTwoFactorAuthenticationMethodVerification) {
        setVerifyStepsData([{
          view: Views.ContactInfo,
          viewProps: {
            contactInfoToDisplay: primaryAccountHolderPhones,
            handleContactInfoUpdate: handlePhoneUpdate,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              onClick: function onClick() {
                return setVerifyStepsIndex(verifyStepsIndex + 1);
              }
            },
            setPhoneNumberToUseForTwoFactorAuthentication: setPhoneNumberToUseForTwoFactorAuthentication,
            twoFactorAuthenticationMethodToBeVerified: TwoFactorAuthenticationMethods.sms,
            context: context,
            phoneNumberToUseForTwoFactorAuthentication: phoneNumberToUseForTwoFactorAuthentication,
            genericErrorMsg: genericErrorMsg,
            allowAbilityToCancel: allowAbilityToCancel,
            cancelBtnProps: {
              className: cancelBtnClassName,
              onClick: handleCancel
            },
            smsTwoFactorAuthenticationMethodVerifiedPhoneData: smsTwoFactorAuthenticationMethodVerifiedPhoneData
          }
        }, {
          view: Views.EnterSecurityCode,
          viewProps: {
            twoFactorAuthenticationMethodToBeVerified: TwoFactorAuthenticationMethods.sms,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              btnType: 'submit'
            },
            contactInfoToUseForTwoFactorAuthentication: phoneNumberToUseForTwoFactorAuthentication,
            handleNextViewNavigation: function handleNextViewNavigation() {
              return setVerifyStepsIndex(verifyStepsIndex + 1);
            },
            fallbackAuthTokenExpiredMsg: fallbackAuthTokenExpiredMsg,
            genericErrorMsg: genericErrorMsg,
            handleSelectDifferentPhoneNumber: function handleSelectDifferentPhoneNumber() {
              return setVerifyStepsIndex(verifyStepsIndex - 1);
            },
            rootRestHubUrl: rootRestHubUrl,
            api: api,
            handleAuthTokenExpiration: handleAuthTokenExpiration,
            context: context,
            allowAbilityToCancel: allowAbilityToCancel,
            cancelBtnProps: {
              className: cancelBtnClassName,
              onClick: handleCancel
            }
          }
        }, {
          view: Views.Success,
          viewProps: {
            verifiedTwoFactorAuthenticationMethod: TwoFactorAuthenticationMethods.sms,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              onClick: handleSetupComplete,
              btnTextOverride: 'Close'
            }
          }
        }]);
      }
    }
  }, [verifyStepsIndex, primaryAccountHolderPhones, primaryAccountHolderEmail, phoneNumberToUseForTwoFactorAuthentication]); // This will determine the set of steps needed for a standard verification based on the two-factor authentication state.

  useEffect(function () {
    if (twoFactorAuthenticationState && !twoFactorAuthenticationMethodVerificationStepsOverrideState && primaryAccountHolderEmail && primaryAccountHolderPhones) {
      var tempVerifyStepsData = [];
      var twoFactorAuthenticationSetupCompleteSuccessViewData = {
        view: Views.Success,
        viewProps: {
          twoFactorAuthenticationSetupComplete: true,
          primaryButtonProps: {
            primaryBtnClassName: primaryBtnClassName,
            primaryBtnIcon: primaryBtnIcon,
            primaryBtnIconClassName: primaryBtnIconClassName,
            onClick: handleSetupComplete
          }
        }
      };

      if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.EnabledWithSmsAndEmailMethodsVerified) {
        tempVerifyStepsData.push(twoFactorAuthenticationSetupCompleteSuccessViewData);
        setVerifyStepsData(tempVerifyStepsData);
        return;
      }

      if (verifyStepsData && verifyStepsData[0] && verifyStepsData[0].view === Views.Intro || !verifyStepsData) {
        tempVerifyStepsData.push({
          view: Views.Intro,
          viewProps: {
            twoFactorAuthenticationState: twoFactorAuthenticationState,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              onClick: function onClick() {
                return setVerifyStepsIndex(1);
              }
            }
          }
        });
      }

      if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndNoVerifiedMethods || twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndSmsMethodNotVerified || twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndNoVerifiedMethods || twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndSmsMethodNotVerified || twoFactorAuthenticationState === TwoFactorAuthenticationStates.EnabledAndSmsMethodNotVerified) {
        tempVerifyStepsData.push({
          view: Views.ContactInfo,
          viewProps: {
            contactInfoToDisplay: primaryAccountHolderPhones,
            handleContactInfoUpdate: handlePhoneUpdate,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              onClick: function onClick() {
                return setVerifyStepsIndex(verifyStepsIndex + 1);
              }
            },
            setPhoneNumberToUseForTwoFactorAuthentication: setPhoneNumberToUseForTwoFactorAuthentication,
            twoFactorAuthenticationMethodToBeVerified: TwoFactorAuthenticationMethods.sms,
            context: context,
            phoneNumberToUseForTwoFactorAuthentication: phoneNumberToUseForTwoFactorAuthentication,
            genericErrorMsg: genericErrorMsg
          }
        });
        tempVerifyStepsData.push({
          view: Views.EnterSecurityCode,
          viewProps: {
            twoFactorAuthenticationMethodToBeVerified: TwoFactorAuthenticationMethods.sms,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              btnType: 'submit'
            },
            handleNextViewNavigation: function handleNextViewNavigation() {
              return setVerifyStepsIndex(verifyStepsIndex + 1);
            },
            fallbackAuthTokenExpiredMsg: fallbackAuthTokenExpiredMsg,
            genericErrorMsg: genericErrorMsg,
            contactInfoToUseForTwoFactorAuthentication: phoneNumberToUseForTwoFactorAuthentication,
            handleSelectDifferentPhoneNumber: function handleSelectDifferentPhoneNumber() {
              return setVerifyStepsIndex(verifyStepsIndex - 1);
            },
            api: api,
            rootRestHubUrl: rootRestHubUrl,
            handleAuthTokenExpiration: handleAuthTokenExpiration,
            context: context
          }
        });

        if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndSmsMethodNotVerified || twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndSmsMethodNotVerified) {
          tempVerifyStepsData.push(twoFactorAuthenticationSetupCompleteSuccessViewData);
        } else {
          tempVerifyStepsData.push({
            view: Views.Success,
            viewProps: {
              verifiedTwoFactorAuthenticationMethod: TwoFactorAuthenticationMethods.sms,
              primaryButtonProps: {
                primaryBtnClassName: primaryBtnClassName,
                primaryBtnIcon: primaryBtnIcon,
                primaryBtnIconClassName: primaryBtnIconClassName,
                onClick: function onClick() {
                  if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.EnabledAndSmsMethodNotVerified) {
                    handleSetupComplete();
                  } else {
                    getUserProfileData();
                  }
                }
              }
            }
          });
        }
      } else if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndEmailMethodNotVerified || twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndEmailMethodNotVerified || twoFactorAuthenticationState === TwoFactorAuthenticationStates.EnabledAndEmailMethodNotVerified) {
        tempVerifyStepsData.push({
          view: Views.ContactInfo,
          viewProps: {
            contactInfoToDisplay: primaryAccountHolderEmail,
            handleContactInfoUpdate: handleEmailUpdate,
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              onClick: function onClick() {
                return setVerifyStepsIndex(verifyStepsIndex + 1);
              }
            },
            twoFactorAuthenticationMethodToBeVerified: TwoFactorAuthenticationMethods.email,
            context: context,
            genericErrorMsg: genericErrorMsg
          }
        });
        tempVerifyStepsData.push({
          view: Views.EnterSecurityCode,
          viewProps: {
            primaryButtonProps: {
              primaryBtnClassName: primaryBtnClassName,
              primaryBtnIcon: primaryBtnIcon,
              primaryBtnIconClassName: primaryBtnIconClassName,
              btnType: 'submit'
            },
            handleNextViewNavigation: function handleNextViewNavigation() {
              return setVerifyStepsIndex(verifyStepsIndex + 1);
            },
            fallbackAuthTokenExpiredMsg: fallbackAuthTokenExpiredMsg,
            genericErrorMsg: genericErrorMsg,
            twoFactorAuthenticationMethodToBeVerified: TwoFactorAuthenticationMethods.email,
            contactInfoToUseForTwoFactorAuthentication: primaryAccountHolderEmail,
            handleEmailUpdate: handleEmailUpdate,
            api: api,
            rootRestHubUrl: rootRestHubUrl,
            handleAuthTokenExpiration: handleAuthTokenExpiration,
            context: context
          }
        });

        if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndEmailMethodNotVerified || twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndEmailMethodNotVerified) {
          tempVerifyStepsData.push(twoFactorAuthenticationSetupCompleteSuccessViewData);
        } else {
          tempVerifyStepsData.push({
            view: Views.Success,
            viewProps: {
              verifiedTwoFactorAuthenticationMethod: TwoFactorAuthenticationMethods.email,
              primaryButtonProps: {
                primaryBtnClassName: primaryBtnClassName,
                primaryBtnIcon: primaryBtnIcon,
                primaryBtnIconClassName: primaryBtnIconClassName,
                onClick: handleSetupComplete
              }
            }
          });
        }
      }

      if (tempVerifyStepsData.length > 0) {
        setVerifyStepsData(tempVerifyStepsData);
      }
    }
  }, [twoFactorAuthenticationState, verifyStepsIndex, phoneNumberToUseForTwoFactorAuthentication, primaryAccountHolderEmail, primaryAccountHolderPhones]); // This will reset the set of steps when the two-factor authentication state changes.

  useEffect(function () {
    if (twoFactorAuthenticationState && prevTwoFactorAuthenticationState.current && prevTwoFactorAuthenticationState.current !== twoFactorAuthenticationState) {
      setVerifyStepsIndex(0);
      setVerifyStepsData([]);
    }
  }, [twoFactorAuthenticationState]);
  useEffect(function () {
    prevTwoFactorAuthenticationState.current = twoFactorAuthenticationState;
  }, [twoFactorAuthenticationState]);
  var determineVerifyStepComponent = useCallback(function () {
    if (verifyStepsData && verifyStepsData[verifyStepsIndex]) {
      var currentVerifyStepData = verifyStepsData[verifyStepsIndex];

      switch (currentVerifyStepData.view) {
        case Views.Intro:
          return React.createElement(IntroView, Object.assign({}, currentVerifyStepData.viewProps));

        case Views.ContactInfo:
          return React.createElement(ContactInfoView, Object.assign({}, currentVerifyStepData.viewProps));

        case Views.EnterSecurityCode:
          return React.createElement(EnterSecurityCodeView, Object.assign({}, currentVerifyStepData.viewProps, {
            siteGrp: siteGrp
          }));

        case Views.Success:
          return React.createElement(SuccessView, Object.assign({}, currentVerifyStepData.viewProps));

        default:
          return null;
      }
    } else {
      return null;
    }
  }, [verifyStepsData, verifyStepsIndex]);
  return React.createElement(StyledTwoFactorAuthenticationSetup, null, mainHeaderHtmlTag && React.createElement("div", {
    className: "header-wrapper"
  }, React.createElement("i", {
    className: "".concat(mainHeaderIconClassName || '', " ").concat(mainHeaderHtmlTag, " fal fa-mobile-alt"),
    style: Object.assign({
      marginRight: '10px'
    }, mainHeaderIconStyles)
  }), React.createElement(MainHeader, null)), (isLoadingAccountManagementDetailsData || isLoadingUserProfileData || isValidatingAccountManagementDetailsData || isValidatingUserProfileData) && React.createElement("div", {
    className: "loading-container"
  }, React.createElement(Loading, null)), !errorMsg && !isLoadingAccountManagementDetailsData && !isValidatingAccountManagementDetailsData && !isLoadingUserProfileData && !isValidatingUserProfileData && determineVerifyStepComponent(), errorMsg && !isLoadingAccountManagementDetailsData && !isLoadingUserProfileData && !isValidatingAccountManagementDetailsData && !isValidatingUserProfileData && React.createElement("p", {
    className: "error"
  }, errorMsg));
};